import "./style.scss";
import { useHandleResize } from "@hook";
import { sendMetric, getWhatId, pluralForm } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import { AVA_TIMING, TITLE_STEP_DELAY_MS } from "../timings";
import shine from "./img/shine.gif";
const { VITE_WHAT_ID } = import.meta.env;

const Ava = inject("mainStore")(
    observer(({ mainStore, setIsFortune, timings, isFortune }) => {
        let abTestMetika = mainStore.getMainStore("abTestMetika");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const init = mainStore.getMainStore("init");
        const settingLego = mainStore.getMainStore("settingLego");
        const preload_data = mainStore.getMainStore("preload_data");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const { preloadWheel } = preload_data;

        const items = preloadWheel.slice(0, 5) || [];
        const [titlePhase, setTitlePhase] = useState("enter");
        const [queue, setQueue] = useState(items);
        const [isAnim, setIsAnim] = useState(false);
        const [startPhase, setStartPhase] = useState("start");
        const isMobile = useHandleResize();
        const avaTiming = timings?.ava || AVA_TIMING;
        const titleStepDelayMs = timings?.titleStepDelayMs ?? TITLE_STEP_DELAY_MS;
        const isTitleExit = queue.length === 0;

        useEffect(() => {
            if (startPhase !== "start") return;

            const startId = setTimeout(() => {
                setStartPhase("");
            }, avaTiming.startMs);

            return () => clearTimeout(startId);
        }, [startPhase, avaTiming.startMs]);

        useEffect(() => {
            if (startPhase === "start" || items.length === 0) return;

            if (isTitleExit) {
                setTimeout(() => {
                    mainStore.setMainStore("isVisible", true);
                    setIsFortune(true);
                }, avaTiming.titleExitMs);

                sendMetric(`widget_step_1_show`, {
                    params1: [`${abTestMetika || "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: null,
                    params8: what_id,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_1_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }
                return;
            }

            const id = setInterval(() => {
                setIsAnim(true);
                setTitlePhase("exit");
                setTimeout(() => {
                    setTitlePhase("enter");
                    setQueue((prev) => prev.slice(1));
                    setIsAnim(false);
                }, avaTiming.animMs);
            }, avaTiming.switchMs);

            return () => clearInterval(id);
        }, [queue.length, startPhase, avaTiming.animMs, avaTiming.switchMs, avaTiming.titleExitMs, mainStore, setIsFortune, isTitleExit]);

        const category = queue[0]?.vendorcategories?.[0]?.title || "";

        const isPartnerHeaderVariant = settingLego.isPartnerHeaderVariant;

        const titleWords = (isPartnerHeaderVariant && init?.data?._p_n ? `${init.data._p_n} анализирует ваши интересы` : "Анализируем ваши интересы").split(" ");

        return (
            <div className={`ava-ai ${startPhase}`}>
                <img src={shine} className="ava-ai__shine" />

                <div className="ava-ai__title">
                    {titleWords.map((word, idx) => {
                        const fromEnd = titleWords.length - 1 - idx;
                        const isPartner = isPartnerHeaderVariant && idx === 0;
                        return (
                            <span key={`${word}-${idx}`} className={`ava-ai__title-word ${isTitleExit ? "is-exit" : "is-enter"} `} style={{ "--delay": `${fromEnd * titleStepDelayMs}ms` }}>
                                {word}
                            </span>
                        );
                    })}
                </div>

                {category && <div className={`ava-ai__category ${titlePhase}`}>{category}</div>}

                <div className={`ava-ai__items ${isAnim ? "is-anim" : ""}`}>
                    {queue.map((i, idx) => (
                        <div className={`ava-ai__item pos-${idx}`} key={idx}>
                            <img className="ava-ai__item-logo" src={isMobile && i?.squareLogo.length ? i?.squareLogo : i?.logoList} />
                            <span className="ava-ai__item-title" dangerouslySetInnerHTML={{ __html: i.title }} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }),
);

export default Ava;
